export const ApplicationContribution = Symbol('ApplicationContribution');
